import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { message } from 'antd';
import App from 'app/App';
import store from 'app/store';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false,
      onError: (error: any) => {
        message.error(
          error.message || `Api call failed. Please contact Focus 360 with the current URL.`,
          5
        );
      },
    },
  },
});

ReactDOM.render(
  <QueryClientProvider client={client}>
    <Provider store={store}>
      <App />
    </Provider>
  </QueryClientProvider>,
  document.getElementById('root')
);

// Set up for Cypress testing
// @ts-ignore
if (window.Cypress) {
  // @ts-ignore
  window.store = store;
}
